import React from 'react';
import { Button, Image, Modal } from 'react-bootstrap';
import instructionsGif from '../../../assets/instructions.gif';

const ExampleModal = ({ open, handleHide, ...props }) =>
// const dispatch = useDispatch();
//
// const [open, setOpen] = useState(true);
//
// const handleHide = () => {
//   setOpen(false);
//   dispatch(setIsTouched(true));
// };

  (
    <Modal
      {...props}
      size="lg"
      show={open}
      animation={false}
      onHide={handleHide}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Gebied bepalen
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>Instructies</h4>
        <p>
          Selecteer het gewenste gebied
          {' '}
          <small>(kleiner dan 15km2)</small>
          {' '}
          door op de kaart de omtrek van het gebied met muisklikken aan te geven. Dubbelklik
          wanneer je het gehele gebied hebt geselecteerd om de selectie compleet te maken.
        </p>
        <p>
          Je kunt de kaart in- of uitzoomen door te scrollen en de kaart verplaatsen door de linkermuisknop ingedrukt te houden en de kaart te verslepen.
        </p>
        <Image fluid src={instructionsGif} alt="Instructie GIF" />
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button onClick={handleHide}>Begrepen</Button>
      </Modal.Footer>
    </Modal>
  );
export default ExampleModal;
